import { render, staticRenderFns } from "./ProductSetForm.vue?vue&type=template&id=3d1215bc&scoped=true"
import script from "./ProductSetForm.vue?vue&type=script&lang=js"
export * from "./ProductSetForm.vue?vue&type=script&lang=js"
import style0 from "./ProductSetForm.vue?vue&type=style&index=0&id=3d1215bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1215bc",
  null
  
)

export default component.exports